import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'
import DivBottom from '../userNotAuth/components/divBottom'
import { useDispatch, useSelector } from 'react-redux'
import { aggiorna } from '../../redux/creaEvento'
import { Link } from 'react-router-dom'

function ModificaEvento() {
    window.scrollTo(0, 0)
    const dispatch = useDispatch()
    let redux = useSelector((state) => state.creaEvento.value)
    redux = { ...redux, newVideo: null, video: null }
    dispatch(aggiorna(redux))
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        {/* <AuthProvider /> */}
        <br /><br />
        <h2 className='m-5'>Evento aggiornato</h2>
        <div className='container' style={{ marginBottom: '15rem' }}>
            <p>
                L'evento è stato modificato ma prima di essere pubblicato dovrà essere approvato dallo staff.<br />
                Potrai modificare l'evento in qualunque momento.
            </p>
            <Link to={{ pathname: `/` }} className='btn btn-secondary'>👉 Torna alla home</ Link>
        </div>
        <DivBottom />
    </>)
}
export default ModificaEvento
